<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<td colspan="8" class="ignore-opacity">
  @if (facade.tags$ | async | tagsByEntity: entityId(); as tags) {
    @if (tags?.length) {
      <div class="d-md-flex gap flex-wrap mb-3">
        @for (tag of tags; track tag.tagId) {
          <web-design-system-tag
            class="d-inline-block mr-2 mb-1 mb-md-0 mr-md-0"
            type="blue"
            [label]="tag.name"
            [isDeletable]="true"
            (delete)="facade.deleteLinkedTag(tag.tagId, entityId())"
          />
        }
      </div>
    }
  }
  @if (currentlyEditingTag() === entityId()) {
    <div class="mt-3 d-flex gap align-items-center">
      <div>{{ 'tags.link-tag.form.label' | transloco }}</div>
      <div class="flex-auto" ngbDropdown #dropdownTrigger="ngbDropdown">
        <div class="input-container" [class.error]="(facade.addTagError$ | async) || tagName?.length > 40">
          <input
            id="link-tag"
            spellcheck="false"
            autocomplete="off"
            ngbDropdownToggle
            type="text"
            [(ngModel)]="tagName"
            [placeholder]="'tags.link-tag.form.placeholder' | transloco"
            (keydown.enter)="addTag()"
            (keydown)="clearErrors()"
            zeroAutofocus
          />
          @if (facade.addTagError$ | async; as error) {
            <div class="message zero-text course-red p-xsmall-reg">{{ error | transloco }}</div>
          }
          @if (tagName?.length > 40) {
            <div class="message zero-text course-red p-xsmall-reg">{{ 'tags.link-tag.form.max-length' | transloco }}</div>
          }
        </div>
        @if (facade.notUsedTags$ | async; as notUsedTags) {
          @if (notUsedTags | tagNameFilter: tagName; as filteredTags) {
            @if (filteredTags.length) {
              <div ngbDropdownMenu aria-labelledby="dropdown">
                @for (tag of filteredTags; track tag.tagId) {
                  <button ngbDropdownItem (click)="addExistingTag(tag.tagId, tag.name)">{{ tag.name }}</button>
                }
              </div>
            }
          }
        }
      </div>
      <web-design-system-button [disabled]="(tagName | tagNameValid) === false" size="small" (click)="addTag()">{{
        'tags.link-tag.form.button' | transloco
      }}</web-design-system-button>
      <web-design-system-icon name="cross" class="cursor-pointer" (click)="cancelLinking.emit($event)" />
    </div>
    <div class="mt-4 mb-3 zero-text label p-small-reg d-flex justify-content-center">{{ 'tags.link-tag.form.hint' | transloco }}</div>
  }
</td>
